<template>
  <div class="blog relative overflow-scroll" id="blog" @wheel.stop>
    <blogWrappers :post="false"/>
    <blogPosts />
  </div>

</template>

<script>
import blogWrappers from "../blog/blogWrappers";
import blogPosts from "../blog/blogPosts";

export default {
  name: "Blog",
  props:['slide'],
  components:{
    blogWrappers,
    blogPosts,
  },
};
</script>

<style scoped>
</style>
